<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="mar_decode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mar_decode || "需求单号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.mar_decode }}
          </div>
        </div>
        <div class="weui-cell" slot="de_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_name || "项目名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_name }}
          </div>
        </div>
        <div class="weui-cell" slot="de_custname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_custname || "需求来源"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_custname }}
          </div>
        </div>
        <div class="weui-cell" slot="de_product_type">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_product_type || "产品类型"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_product_type }}
          </div>
        </div>
        <div class="weui-cell" slot="de_emname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_emname || "需求人"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_emname }}
          </div>
        </div>
        <div class="weui-cell" slot="de_dpname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            {{ form.main.de_dpname }}
          </div>
        </div>
        <div class="weui-cell" slot="mar_project_classify">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mar_project_classify || "项目分类"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mar_project_classify"
              placeholder="请选择"
            >
              <option>销售立项</option>
              <option>产品立项</option>
              <option>技术立项</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="mar_project_level">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mar_project_level || "项目等级"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mar_project_level"
              placeholder="请选择"
            >
              <option>高</option>
              <option>中</option>
              <option>低</option>
            </select>
          </div>
        </div>
        <employee-field
          :label="customLabel.mar_emname || '项目负责人'"
          v-model="form.main.mar_emname"
          @select="onSelectEmployee"
          slot="mar_emname"
        />

        <div class="weui-cell" slot="mar_budget">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mar_budget || "项目预算金额"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.mar_budget"
              placeholder="请输入"
            />
          </div>
        </div>
        <currency-field
          slot="mar_currency"
          :label="customLabel.mar_currency || '币种'"
          v-model="form.main.mar_currency"
        />
        <div class="weui-cell" slot="mar_market_analyse">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mar_market_analyse || "行业与市场分析"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.mar_market_analyse"
              placeholder="请输入行业与市场分析"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-cell" slot="mar_products_analyse">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mar_products_analyse || "竞争对手/竞品对标分析"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.mar_products_analyse"
              placeholder="请输入竞争对手/竞品对标分析"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-cell" slot="mar_potential_risk">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mar_potential_risk || "潜在风险"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="form.main.mar_potential_risk"
              placeholder="请输入潜在风险"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
      </custom-layout>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.mar_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    EmployeeField,
    CurrencyField,
    FileField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/plm/marketAnalyseReport",
      codeField: "mar_code",
      statusField: "mar_statuscode",
      caller: "MarketAnalyseReport",
      xtype: "plm-marketanalysereport-formpanel",
      form: {
        main: {
          mar_deid: null,
          mar_decode: null,
          de_name: null,
          mar_budget: null,
          mar_emid: null,
          mar_emcode: null,
          mar_emname: null,
          mar_project_level: null,
          mar_project_classify: null,
          mar_currency: null,
          mar_market_analyse: null,
          mar_products_analyse: null,
          mar_potential_risk: null,
        },
      },
    };
  },
  methods: {
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.mar_emid = selection.id;
      main.mar_emcode = selection.em_code;
    },

    /**
     * 保存
     */
    save() {
      var me = this;
        me.p_save();
    },
  },
};
</script>
